import { Collapse } from "@mui/material";
import ButtonCollapse from "components/shared/ButtonCollapse";
import type { ReactNode } from "react";
import { useState } from "react";

interface InactiveItemsCollapseProps {
    label: string;
    children: ReactNode;
    /** Optional control aligned on the opposite side of the collapse trigger (e.g. add channel). */
    trailingAction?: ReactNode;
}

/**
 * Collapsible section for inactive contract channels or compensation groups (edit mode).
 */
const InactiveItemsCollapse = ({ label, children, trailingAction }: InactiveItemsCollapseProps) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className="inactive-channels-collapse">
            <div className="inactive-channels-collapse-header">
                <ButtonCollapse collapse={isOpen} onCollapse={() => setIsOpen((prev) => !prev)} btnText={label} />
                {trailingAction}
            </div>
            <Collapse in={isOpen} timeout={500} unmountOnExit>
                <div className="inactive-channels-collapse-content">{children}</div>
            </Collapse>
        </div>
    );
};

export default InactiveItemsCollapse;
